import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Chip,
} from '@mui/material';

const mockClients = [
  {
    id: 1,
    name: 'John Doe',
    status: 'active',
    balance: 5000,
    joinDate: '2024-01-15',
    bets: 150,
  },
  {
    id: 2,
    name: 'Jane Smith',
    status: 'inactive',
    balance: 2500,
    joinDate: '2024-02-01',
    bets: 75,
  },
  {
    id: 3,
    name: 'Mike Johnson',
    status: 'active',
    balance: 7500,
    joinDate: '2024-01-10',
    bets: 200,
  },
];

export default function Clients() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Client Management
      </Typography>
      
      <Paper sx={{ p: 3 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Balance</TableCell>
                <TableCell>Join Date</TableCell>
                <TableCell align="right">Total Bets</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mockClients.map((client) => (
                <TableRow key={client.id}>
                  <TableCell>{client.name}</TableCell>
                  <TableCell>
                    <Chip
                      label={client.status.toUpperCase()}
                      color={client.status === 'active' ? 'success' : 'error'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="right">${client.balance}</TableCell>
                  <TableCell>{client.joinDate}</TableCell>
                  <TableCell align="right">{client.bets}</TableCell>
                  <TableCell>
                    <Button size="small" variant="outlined">
                      View Details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
} 